import { render, staticRenderFns } from "./userDetalis.vue?vue&type=template&id=54e90b22&scoped=true&"
import script from "./userDetalis.vue?vue&type=script&lang=js&"
export * from "./userDetalis.vue?vue&type=script&lang=js&"
import style0 from "./userDetalis.vue?vue&type=style&index=0&id=54e90b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e90b22",
  null
  
)

export default component.exports